module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"New Category":"Neue Kategorie","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Category list could not be fetched.":"Kategorieliste konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
